import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SessionService } from '@app-store/session/session.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export function canViewFloDashboard(authenticated: boolean, roles?: string[]): boolean {
	return authenticated && Array.isArray(roles) && roles.includes('ADMIN');
}

@Injectable({ providedIn: 'root' })
export class FloAdminGuard implements CanActivate {
	constructor(private session: SessionService, private router: Router, private toastr: ToastrService) {}

	canActivate(): Observable<boolean | UrlTree> {
		return this.session.isAuthenticated().pipe(
			take(1),
			switchMap(authenticated =>
				authenticated
					? this.session.getUser().pipe(
							take(1),
							map(user => {
								if (canViewFloDashboard(authenticated, user?.roles)) return true;
								this.toastr.error('O Dashboard da Flô está disponível somente para administradores.');
								return this.router.parseUrl('/painel/home');
							})
					  )
					: of(this.router.parseUrl('/login'))
			),
			catchError(error => {
				if (error?.status === 401) this.session.logout();
				this.toastr.error(
					error?.status === 403
						? 'Você não tem permissão para acessar o Dashboard da Flô.'
						: error?.status === 401
						? 'Sua sessão expirou. Entre novamente.'
						: 'Não foi possível validar suas permissões. Tente novamente.'
				);
				return of(this.router.parseUrl(error?.status === 401 ? '/login' : '/painel/home'));
			})
		);
	}
}
